import { useState, useContext } from "react";
import { Button, Container, Form, InputGroup, Spinner } from "react-bootstrap";
import { FaEnvelope, FaEye, FaEyeSlash, FaLock } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import "../../../assets/css/Drivers/DriverAuth/DriverLogin.css";
import logo from "../../../assets/images/TrustiDrivelogo.png";
import axios from "axios";
import AppContext from "../../../context/AppContext";

const DriverLogin = () => {
  const { baseUrl, RegExpChecker, setAuthToken } = useContext(AppContext);
  const [driverEmail, setdriverEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setshowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);
  // Login par sirf email format check, password ki strict validation signup par hai
  const [errors, setErrors] = useState({ email: "" });

  const navigate = useNavigate();

  const isFormValid = driverEmail && password && !errors.email;

  const handleLogin = () => {
    if (!isFormValid) return;
    setLoading(true);

    const formData = new FormData();
    formData.append("driverEmail", driverEmail.trim());
    formData.append("password", password);

    // Content-Type header nahi lagana, axios FormData ke saath boundary khud set karta hai
    axios
      .post(`${baseUrl}/driver/profile/loginDriver`, formData)
      .then((response) => {
        setLoading(false);
        if (response.data.success === true) {
          localStorage.setItem("authToken", response.data.token);
          localStorage.setItem(
            "tddriver",
            JSON.stringify(response.data.tddriver)
          );
          setAuthToken(response.data.token);
          setdriverEmail("");
          setPassword("");
          navigate("/driver-dashboard");
        } else {
          // Galat credentials par form clear nahi hota
          alert("Invalid Credentials. Try again with correct one.");
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        alert("Network Error! Please try again.");
      });
  };

  return (
    <div className="driver-login-wrapper">
      <Container className="driver-login-container">
        <div className="driver-login-card">
          {/* Logo Section */}
          <div className="driverlogin-logo-section">
            <img src={logo} alt="TrustiDrive" className="driverlogin-logo" />
          </div>

          {/* Welcome Text */}
          <div className="driverlogin-welcome-text">
            <h2 className="driverlogin-title">Let's you in</h2>
            <p className="driverlogin-subtitle">Hey, Driver! Welcome!</p>
          </div>

          {/* Login Form */}
          <Form onSubmit={(e) => e.preventDefault()}>
            {/* Email Input */}
            <Form.Group className="driver-login-form-group">
              <Form.Label className="driver-login-label">Email</Form.Label>
              <InputGroup className="driver-login-input-group">
                <InputGroup.Text className="driver-login-input-icon">
                  <FaEnvelope />
                </InputGroup.Text>
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  value={driverEmail}
                  onChange={(e) => {
                    const value = e.target.value;
                    setdriverEmail(value);

                    const regError = RegExpChecker("email", value.trim());
                    setErrors({ email: value && regError ? regError : "" });
                  }}
                />
              </InputGroup>
              {errors.email && (
                <small className="text-danger">{errors.email}</small>
              )}
            </Form.Group>

            {/* Password Input */}
            <Form.Group className="driver-login-form-group">
              <Form.Label className="driver-login-label">Password</Form.Label>
              <InputGroup className="driver-login-input-group">
                <InputGroup.Text className="driver-login-input-icon">
                  <FaLock />
                </InputGroup.Text>
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />

                <InputGroup.Text
                  className="driver-login-eye-icon"
                  onClick={() => setshowPassword(!showPassword)}
                  style={{ cursor: "pointer" }}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </InputGroup.Text>
              </InputGroup>
            </Form.Group>

            {/* Remember Me & forgot Password */}
            <div className="driver-login-options">
              <Form.Check
                type="checkbox"
                label="Remember me"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                className="driver-login-checkbox"
              />
              <div className="driver-login-forgot-link">
                <Link to="/driver-forgot-password">forgot Password?</Link>
              </div>
            </div>

            {/* Login Button */}
            <Button
              type="button"
              className="driver-login-submit-btn"
              onClick={handleLogin}
              disabled={!isFormValid || loading}
            >
              {loading ? (
                <div className="btn-content-wrapper">
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  <span className="ms-2">Loading...</span>
                </div>
              ) : (
                "Login"
              )}
            </Button>
          </Form>

          {/* Sign Up Link */}
          <p className="driver-login-signup-text">
            New User? <Link to="/Driver-signup">Sign up</Link>
          </p>
        </div>
      </Container>
    </div>
  );
};

export default DriverLogin;